import React from 'react'
import PropTypes from 'prop-types'

import { Text, Icon } from 'passiv-components'

const Away = ({ icon, badge, awayTile }) => {
  return (
    <>
      <Text
        type="title-condensed"
        className="sm:menu-tile-title absolute pt-2 top-0 w-full text-center"
        ariaHidden={true}
      >
        {awayTile.label}
      </Text>
      {false ? (
        <div className="flex-center w-full h-full">
          <Icon className="text-grey w-12 h-9 sm:w-9" icon="menu" />
        </div>
      ) : (
        <Icon className="w-12 h-9 sm:w-9" icon={icon} badge={badge} away={awayTile} />
      )}
    </>
  )
}

Away.propTypes = {
  icon: PropTypes.string,
  badge: PropTypes.string,
  awayTile: PropTypes.string
}

export default Away
